/* eslint-disable arrow-body-style */
import React from 'react';

import { FilterPanelHeader } from '@src/common/FilterPanelPage/FilterPanelHeader';
import { MonthSelect } from './filterPanelComponents/MonthSelect';
import { PortalsSelect } from './filterPanelComponents/PortalsSelect';
import { EventsSelect } from './filterPanelComponents/EventsSelect';
import { TypeSelect } from './filterPanelComponents/TypeSelect';
import { ValueField } from './filterPanelComponents/ValueField';
import { SearchButton } from './filterPanelComponents/SearchButton';
import { EventSearchBreadcrumbs } from './EventSearchBreadcrumbs';
import { EvtSearchLoadingAttr } from './filterPanelComponents/EvtSearchLoadingAttr';

export const EventSearchFilterPanel = () => {
  return (
    <React.Fragment>
      <EvtSearchLoadingAttr />
      <EventSearchBreadcrumbs />
      <FilterPanelHeader />
      <MonthSelect />
      <PortalsSelect />
      <EventsSelect />
      <TypeSelect />
      <ValueField />
      <SearchButton />
    </React.Fragment>
  );
};
